// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jkCZE8fQ7Ozm5kyDOnp2{display:flex;justify-content:space-between;padding:30px 20px 0}`, "",{"version":3,"sources":["webpack://./src/components/Conversations/ConversationsNav/ConversationsNavHead/conversations-nav-head.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,6BAAA,CACA,mBAAA","sourcesContent":[".conversationsNavHead {\n    display: flex;\n    justify-content: space-between;\n    padding: 30px 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"conversationsNavHead": `jkCZE8fQ7Ozm5kyDOnp2`
};
export default ___CSS_LOADER_EXPORT___;
